var React = require('react');
var createReactClass = require('create-react-class');
var PureRenderMixin = require('react-addons-pure-render-mixin');

var DashboardWrapper = createReactClass({
    mixins: [PureRenderMixin],

    render: function(){
        return (
            <div className={this.props.params.surveyType ? ' survey-content' : ' dashboard-content'}>
                {this.props.children}
            </div>
        );
    }
});

module.exports = DashboardWrapper;



// WEBPACK FOOTER //
// ./src/common/routes/dashboard/components/dashboardWrapper.jsx